import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText, CardActions} from 'material-ui/Card';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import en from 'naughty-words/en.json';
import fi from 'naughty-words/fi.json';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Download from 'material-ui/svg-icons/file/file-download';

class StandTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 5,
      amountError: '',
      fiShort: [],
      enShort: [],
      buttonDisabled: false
    };
  }
  componentDidMount = () => {
    const enShort = en.filter((word) => (word.length <= 5 && word.length > 2));
    const fiShort = fi.filter((word) => (word.length <= 5));
    this.setState({enShort, fiShort});
  }

  handleAmountChange = (event, amount) => this.setState({amount, amountError: ''})

  validateAmount = () => {
    const amount = this.state.amount;

    if (!amount) {
      this.setState({amountError: 'An amount is required'});
      return false;
    } else if (isNaN(amount)) {
      this.setState({amountError: 'Amount is not a number'});
      return false;
    } else if (parseInt(amount, 10) < 0)  {
      this.setState({amountError: 'Amount cannot be less than zero'});
      return false;
    }

    return true;
  }

  generateNewIds = (amount) => {
    return new Promise((resolve) => {
      var newIds = [];
      this.props.firebase.database().ref('standTag').transaction((data) => {
        if (!data) return data;

        while (newIds.length < amount) {
          data.number += data.step;
          var nextId = this.generateNextId(data.digits, data.number, data.alphabet);
          var isBadEnglishWord = this.state.enShort.some(v => nextId.indexOf(v) >= 0); // eslint-disable-line
          var isBadFinnishWord = this.state.fiShort.some(v => nextId.indexOf(v) >= 0); // eslint-disable-line
          if (!isBadEnglishWord && !isBadFinnishWord) {
            newIds.push(nextId);
          }
        }

        return data;
      }, () => {
        resolve(newIds);
      });
    });
  }

  generateNextId = (idLength, currentNumber, alphabet) => {
    var str = '';
    for (var j = 0; j < idLength; j++) {
      var digit = currentNumber % alphabet.length;
      currentNumber = (currentNumber - digit) / alphabet.length;
      str = alphabet.charAt(digit) + str;
    }
    return str;
  }


  regenerateDuplicates = (newTags) => {
    return new Promise((resolve) => {
      var promises = newTags.map((newTag) =>(this.props.firebase.database().ref('standcodes/' + newTag).once('value') ));

      Promise.all(promises).then((snapshots) => {
        const uniqueKeys = snapshots
          .map((snapshot, i) => (!snapshot.exists() ? i : -1 ))
          .filter((i) => (i > -1))
          .map((i) => newTags[i]);

        if (uniqueKeys.length < newTags.length) {
          this
            .generateNewIds(newTags.length - uniqueKeys.length)
            .then((generatedNewKeys) => {
              resolve(uniqueKeys.concat(generatedNewKeys));
            });
        }

        resolve(uniqueKeys);
      });
    });
  }

  downloadFile = (data) => {
    const dataToCsvURI = encodeURI(`data:text/plain;charset=utf-8,${data.join('\r\n')}`);
    const link = document.createElement('a');
    link.setAttribute('href', dataToCsvURI);
    link.setAttribute('download', 'standTags.txt');
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
    this.setState({buttonDisabled: false});
  }

  saveTags = (newTags) => {
    return new Promise((resolve) => {
      var promises = newTags.map((newTag) =>(this.props.firebase.database().ref('standcodes/' + newTag).set(true) ));
      Promise.all(promises).then(() => {resolve(newTags)});
    });
  }

  showAlert = (generateAmount) => (
    (newTags) => (
      new Promise((resolve) => {
        if (generateAmount > newTags.length) {
          alert('Not all standTags could be generated, just ' + newTags.length + ' could be generated');
        }
        resolve(newTags);
      })
    )
  )

  generateTags = () => {
    if(!this.validateAmount()) return;
    this.setState({buttonDisabled: true});

    const generateAmount = parseInt(this.state.amount,10);
    this.generateNewIds(generateAmount)
      .then(this.regenerateDuplicates)
      .then(this.saveTags)
      .then(this.showAlert(generateAmount))
      .then(this.downloadFile);
  }

  render() {
    const {t} = this.props;
    return (
        <Card className='cardStyle'>
          <Toolbar>
            <ToolbarGroup>
              <ToolbarTitle text={t('standTags')} />
            </ToolbarGroup>
          </Toolbar>
          <CardText style={{textAlign: 'left', position: 'relative'}}>
            <TextField
              hintText={t('amount')}
              floatingLabelText={t('amount')}
              onChange={this.handleAmountChange}
              value={this.state.amount}
              onBlur={this.validateAmount}
              errorText={this.state.amountError}
            />
          </CardText>
          <CardActions>
            <RaisedButton primary
              label={t('generateTags')}
              icon={<Download />}
              onTouchTap={this.generateTags}
              disabled={this.state.buttonDisabled}/>
          </CardActions>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(StandTag);



// WEBPACK FOOTER //
// ./src/Admin/StandTag.js